import React, { useMemo } from 'react';
import styled from 'styled-components';
import { useObserver } from '../../../CodesThatsGottaGoSomewhereElse';
import { Colors } from '../../../ui';
import { Badge } from '../../../ui/Badge';
import { Participant } from '../../canvas/participants/Participant';
import { Counter } from '../../common/Users';
import { HangoutUser } from '../../hangouts/HangoutUser';
import { HangoutLocationObserver, useHangoutLocationObserver } from '../../hangouts/helpers/HangoutLocationObserver';
import { Flexer } from './LayoutElements';

const Frame = styled.div`
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: end;
    padding: .25rem;
`;

const BoardParticipant = React.memo<{ user: HangoutUser }>(({ user }) => {
    const { name, color, photo } = useObserver(user);
    return <Counter size={1.5} color={color} photo={photo}>
        {Participant.toInitials(name)}
    </Counter>;
});

export const BoardParticipantPreview = React.memo<{ boardId: string }>(({ boardId }) =>
    <HangoutLocationObserver locationId={`board:${boardId}`} render={(users) => <>
        {!!users.length && <Frame>
            {users.map(x => <BoardParticipant key={x.id} user={x} />)}
        </Frame>}
    </>} />
);

const HangoutLocationUserListItem = React.memo<{ user: HangoutUser }>(({ user }) => {
    const { name, color, photo } = user;// useObserver(user);
    return <Counter size={1.5} color={color} photo={photo}>
        {Participant.toInitials(name)}
    </Counter>;
});

export const LiveBoardInfo = React.memo<{ path: string, max?: number }>(({ path, max }) => {

    max = max || 10;
    const users = useHangoutLocationObserver(path);
    const [visible, rest] = useMemo(() => [users?.slice(0, max), users?.slice(max)], [users, max]);

    if (!users?.length) return null;

    return <Flexer inset flex="row" align="end" justify="end" padding=".25">
        <Flexer absolute left=".25" top=".25">
            <Badge color={Colors.positive}>LIVE</Badge>
        </Flexer>
        {visible?.map(x => <HangoutLocationUserListItem key={x.id} user={x} />)}
        {!!rest?.length && <Counter size={1.5} color="gray">{`+${rest.length}`}</Counter>}
    </Flexer>;
});
